import { render, staticRenderFns } from "./VatChecker.vue?vue&type=template&id=1dbc8e4e&"
import script from "./VatChecker.vue?vue&type=script&lang=js&"
export * from "./VatChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports